/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { Link } from "react-router-dom";
import moment from "helpers/moment";
import Skeleton from "react-loading-skeleton";

/* Helpers, constants, custom methods, internal libraries */
import {FormattedMessage} from "react-intl";
import { useLocaleContext } from "../../../contexts/localeContext.js";
import { usePolicyService } from "../../../services/policyService.js";
import { POLICY_ROUTE } from "../../../constants/routes.js";

/* Components */
/* Styles */
import styles from "./styles.js"


const Content = ({ policyDetails, setPolicyDetails }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const globalLocale = useLocaleContext();
  const [showSkeleton, setShowSkeleton] = useState(false);

  const { teamPolicies, getTeamPolicies } = usePolicyService();

  useEffect(() => {
    (async () => {
      setShowSkeleton(true)
      await getTeamPolicies();
      setShowSkeleton(false)
    })();
  }, []);

  const renderPolicyContent = () => {
    return(
      teamPolicies.map((item) => (        
        <div key={item?.policyId} className={policyDetails !== null && policyDetails?.policyId == item.policyId ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer} onClick={() => setPolicyDetails(item)}>
          <div className={classes.cardDetails}>
            <h3 className={classes.policyName}>{item?.policyName}</h3>
            <p><FormattedMessage id="changePolicyModal.lastUpdated" /> {moment(item?.updatedOn).locale(globalLocale).format("D MMM YYYY")}</p>
          </div>
          <div>
            <input
              onChange={() => setPolicyDetails(item)}
              type="radio"
              name={item?.policyId}
              id={item?.policyId}
              checked={policyDetails !== null && policyDetails?.policyId == item?.policyId ? "checked" : ""}
            />
          </div>
        </div>
      ))
    )
  }

  return (
    <div className={classes.modalContent}>
      <div className={classes.scrollableContainer}>
        {
          showSkeleton  ? 
            <div className={classes.optionContainer}>
              <div>
                <h3><Skeleton count={1} width={100} /></h3>
                <p><Skeleton count={1} width={300} /></p>
              </div>
            </div>
            :
            <div className={policyDetails == null ? `${classes.optionContainer} ${classes.selectedOptionContainer}` : classes.optionContainer} onClick={() => setPolicyDetails(null)}>
              <div>
                <h3>
                  <FormattedMessage id="changePolicyModal.noPolicy.title"/>
                </h3>
                <p>
                  <FormattedMessage id="changePolicyModal.noPolicy.description"/>
                </p>
              </div>
              <div>
                <input
                  onChange={() => setPolicyDetails(null)}
                  type="radio"
                  name="noPolicy"
                  id='noPolicy'
                  checked={policyDetails == null ? "checked" : ""}
                />
              </div>
            </div>
        }
        { teamPolicies && renderPolicyContent()}
      </div>
      <div className={classes.linkContainer}>
        <FormattedMessage id="changePolicyModal.addNewPolicies"/>
        <Link to={POLICY_ROUTE}>
          <FormattedMessage id="changePolicyModal.policyTab"/>
        </Link>
      </div>
    </div>
  )
}

export default Content;
